/**
 * Sum up amounts in varying currencies.
 * Maintains grouping by currency
 **/
export function multiCurrencySum(
  values: Array<{ currency: string; amount: number }>,
) {
  const result: Record<string, number> = {};
  for (const v of values) {
    if (!(v.currency in result)) {
      result[v.currency] = 0;
    }
    result[v.currency] += v.amount;
  }
  return result;
}

// NumberFormat isn't stable across SSR:
// https://github.com/vercel/next.js/discussions/19409
const WELL_KNOWN_CURRENCIES = new Set([
  'USD',
  'GBP',
  'EUR',
  'JPY',
  'CNY',
  'AUD',
  'CAD',
  'HKD',
  'SGD',
]);
export function numberStd(amount: number, digits = 0) {
  const repr = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'ALL',
    notation: 'compact',
    compactDisplay: 'long',
    maximumFractionDigits: digits,
    // currencyDisplay: WELL_KNOWN_CURRENCIES.has(currency)
    //     ? 'narrowSymbol'
    //     : 'code',
  }).format(amount);
  return repr;
}
export function formatCurrency(currency: string, amount: number, digits = 0) {
  const repr = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    notation: 'compact',
    compactDisplay: 'long',
    maximumFractionDigits: digits,
    currencyDisplay: WELL_KNOWN_CURRENCIES.has(currency)
      ? 'narrowSymbol'
      : 'code',
  }).format(amount);

  return repr;
}

export function formatMultiCurrency(values: Record<string, number>) {
  return Object.entries(values)
    .map(([currency, amount]) => formatCurrency(currency, amount))
    .join(', ');
}
